import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	timeTrackingFieldName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	timeTrackingFieldName: {
		id: 'issue-create.common.fields.time-tracking-field.time-tracking-field-name',
		defaultMessage: 'Original Estimate',
		description: 'Label for time tracking field',
	},
});
export default messages;
